import { Button, ButtonGroup, styled } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';
import { DashboardPeriod, DashboardService } from '~/service/service.dashboard';
import { useService } from '~/shared/service/service.base';
import { useTr } from '~/text';
import { Box } from '../view.box';

export type DashboardButtonGroupProps = {
	periods: DashboardPeriod[];
};

interface StyledButtonProps {
	selected?: boolean;
}

const StyledButton = styled(Button, {
	shouldForwardProp: prop => prop !== 'selected',
})<StyledButtonProps>(({ theme: { palette }, selected }) => ({
	borderRadius: 36,
	borderColor: palette.grey[300],
	backgroundColor: selected ? palette.grey[100] : 'transparent',
	color: selected ? palette.text.primary : palette.text.secondary,
	textTransform: 'unset',
}));

export const DashboardPeriodGroup: FC<DashboardButtonGroupProps> = observer(({ periods }) => {
	const [svc] = useService(DashboardService);
	const t = useTr(['dashboardPeriods']);

	return (
		<Box alignItems="center" gap={1}>
			<ButtonGroup variant="outlined" color="inherit">
				{periods.map(period => (
					<StyledButton key={period} selected={svc.period === period} onClick={() => svc.setPeriod(period)}>
						{t(period)}
					</StyledButton>
				))}
			</ButtonGroup>
		</Box>
	);
});

export const DashboardPeriodDates: FC = observer(() => {
	const [svc] = useService(DashboardService);
	if (!svc.periodDates) return false;

	return (
		<StyledButton
			color="inherit"
			variant="outlined"
			disableRipple
			sx={{ cursor: 'default', ':hover': { background: 'unset' } }}
		>
			{svc.periodDates.from} - {svc.periodDates.to}
		</StyledButton>
	);
});
